<template>
  <v-dialog v-model="opened" max-width="600">
    <v-card>
      <v-card-title>Amazonアフィリエイト</v-card-title>
      <v-card-actions class="pw-10">
        <v-tabs>
          <v-tab href="#keyword">キーワード検索</v-tab>
          <v-tab href="#url">URLを入力</v-tab>
          <v-tab-item value="keyword">
            <v-form
              ref="amazonApApiSearchForm"
              style="width: 100%"
              lazy-validation
              @submit.prevent="searchKeyword()"
            >
              <v-row>
                <v-col cols="10">
                  <v-text-field
                    v-model="keywords"
                    label="キーワード入力"
                    class="pw-5"
                  />
                </v-col>
                <v-col>
                  <v-btn color="primary" @click="searchKeyword()">検索</v-btn>
                </v-col>
              </v-row>
            </v-form>
            <v-row justify="space-around">
              <v-flex
                v-show="!loading"
                v-for="(product, index) in searchResultProducts"
                :key="index"
                md4
                max-width="200"
              >
                <a @click="$emit('select-product', product)">
                  <v-img
                    :src="product.images.primary.large.url"
                    min-height="100"
                    max-height="200"
                    max-width="200"
                    class="ma-1"
                  ></v-img>
                  <p>
                    {{
                      brandDisplayValue(product)
                        ? product.itemInfo.byLineInfo.brand.displayValue
                        : 'ブランド名なし'
                    }}
                  </p>
                  {{ product.itemInfo.title.displayValue }}
                </a>
              </v-flex>
              <v-flex
                v-for="key in '123456'"
                v-show="loading"
                :key="`skeleton_${key}`"
                class="px-2"
                md4
                max-width="200"
              >
                <v-skeleton-loader type="image, article"></v-skeleton-loader>
              </v-flex>
              <v-card-text class="text-center">
                <span v-if="!haveItems()">検索結果がありません</span>
              </v-card-text>
            </v-row>
          </v-tab-item>
          <v-tab-item value="url">
            <v-form
              ref="amazonApApiSearchUrlForm"
              style="width: 100%"
              lazy-validation
              @submit.prevent="searchUrl()"
            >
              <v-row>
                <v-col cols="10">
                  <v-text-field
                    v-model="url"
                    label="URL入力"
                    :rules="[amazonUrlValidation]"
                  />
                </v-col>
                <v-col>
                  <v-btn color="primary" @click="searchUrl()">設定</v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-tab-item>
        </v-tabs>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios'

export default {
  props: {
    dialog: {
      type: Boolean,
      required: true
    }
  },
  data: function () {
    return {
      searchResultProducts: [],
      keywords: '',
      url: '',
      opened: this.dialog,
      loading: false,
      amazonUrlValidation: function (value) {
        if (value.match(/\/dp\/(\w+)/)) {
          return true
        } else {
          return '正しいAmazonURLを入力してください'
        }
      }
    }
  },
  watch: {
    dialog () {
      this.opened = this.dialog
    },
    opened (value) {
      if (value) return
      this.$emit('close-dialog', false)
    }
  },
  methods: {
    brandDisplayValue (product) {
      if (
        product.itemInfo.byLineInfo &&
        product.itemInfo.byLineInfo.brand &&
        product.itemInfo.byLineInfo.brand.displayValue
      ) {
        return true
      } else {
        return false
      }
    },
    searchKeyword () {
      if (!this.$refs.amazonApApiSearchForm.validate()) {
        return
      }

      this.loading = true
      this.searchResultProducts = []
      const params = {
        params: {
          keywords: this.keywords
        }
      }
      axios
        .get('/api/amazon_pa_api', params)
        .then(
          ({ data }) => {
            this.searchResultProducts.push(...data)
          },
          (error) => {
            const payload = {
              status: error.response.status,
              message: error.response.statusText
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          }
        )
        .finally(() => {
          this.loading = false
        })
    },
    searchUrl () {
      if (!this.$refs.amazonApApiSearchUrlForm.validate()) {
        return
      }
      this.$store.dispatch('LoaderStore/displayLoader')
      const params = {
        params: {
          amazon_id: this.url.match(/\/dp\/(\w+)/)[1]
        }
      }
      axios
        .get('/api/amazon_pa_api/get_item', params)
        .then(
          ({ data }) => {
            this.$emit('select-product', data)
          },
          (error) => {
            const payload = {
              status: error.response.status,
              message: error.response.statusText
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          }
        )
        .finally(() => {
          this.$store.dispatch('LoaderStore/hideLoader')
        })
    },
    haveItems () {
      return this.searchResultProducts && !!this.searchResultProducts.length
    }
  }
}
</script>
